var map = {
	"./animal.png": 16,
	"./building.png": 17,
	"./city.png": 18,
	"./earth.png": 19,
	"./energy.png": 20,
	"./event.png": 21,
	"./jovian.png": 22,
	"./leaf.png": 23,
	"./microbe.png": 24,
	"./none.png": 25,
	"./questionMark.png": 26,
	"./science.png": 27,
	"./space.png": 28,
	"./terraforming-mars-icons.png": 29,
	"./venus.png": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;